import { Inject, Injectable, forwardRef} from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';

import  { Observable } from 'rxjs/Observable';

import { HttpClient } from './http-client.service';

import { Report } from '../../entities/report';

import { Settings } from '../../settings';

import { DateConverter } from '../../utility/date-converter';

import { ODataBuilder } from '../../utility/odata/odata-builder';
import { ODataComparer } from '../../utility/odata/odata-comparer';

import { CachedCallService } from './cached-call.service';

@Injectable()
export class ReportService {
  private readonly headers:Headers = new Headers({ 'Content-Type': 'application/json' });
  private readonly options:RequestOptions = new RequestOptions({ headers: this.headers });

  private static readonly reportBaseUrl:string = `${Settings.apiUrl}/v1/Reports`;

  protected cachedCallService:CachedCallService = new CachedCallService();

  constructor(@Inject(forwardRef(() => HttpClient)) private http:HttpClient) { }

  getReports(): Promise<Report[]> {

    let oDataBuilder: ODataBuilder = new ODataBuilder(ReportService.reportBaseUrl);

    oDataBuilder
      .expand('ReportSubCategory($expand=ReportCategory)')
      .expand('ReportOrganizationType')
      .expand('ReportSecurityGroups($expand=SecurityGroup)')
      .orderBy("SortOrder");

    let reportUrl: string = oDataBuilder.toString();

    return this.http.get(reportUrl)
      .toPromise()
      .then(response => response.json().value);

  }

  getReportCountByReportCategoryId(reportCategoryId: string): Promise<number> {
    let oDataBuilder: ODataBuilder = new ODataBuilder(ReportService.reportBaseUrl);

    let reportUrl:string = `${ReportService.reportBaseUrl}/?$filter=ReportSubCategory/ReportCategoryId eq ${reportCategoryId}&$top=0&$count=true`;

    return this.http.get(reportUrl)
      .toPromise()
      .then(response => {
        return response.json()['@odata.count'];
      });
  }

  getReportCountByReportSubCategoryId(reportSubCategoryId: string): Promise<number> {
    let oDataBuilder: ODataBuilder = new ODataBuilder(ReportService.reportBaseUrl);

    let reportUrl:string = `${ReportService.reportBaseUrl}/?$filter=ReportSubCategoryId eq ${reportSubCategoryId}&$top=0&$count=true`;

    return this.http.get(reportUrl)
      .toPromise()
      .then(response => {
        return response.json()['@odata.count'];
      });
  }

  createReport(report: Report): Promise<Report> {
    let reportUrl: string = `${Settings.apiUrl}/v1/Reports`;
    
    // must remove - breaks deserialization on the server when trying to convert empty string to Guid 
    delete report.ReportId;

    return this.http.post(reportUrl, JSON.stringify(report), this.options)
      .toPromise()
      .then(response => {
        return response.json();
      });
  }

  updateReport(report: Report): Promise<null> {

    let reportUrl: string = `${Settings.apiUrl}/v1/Reports(${report.ReportId})`;

    return this.http.put(reportUrl, JSON.stringify(report), this.options)
      .toPromise()
      .then(response => response);
  }

  patchReport(report: Report): Promise<null> {

    let reportUrl: string = `${Settings.apiUrl}/v1/Reports(${report.ReportId})`;

    return this.http.patch(reportUrl, JSON.stringify(report), this.options)
      .toPromise()
      .then(response => response);
  }
} 



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/services/http/report.service.ts